/**
 * Entrata delle sezioni Maison Dieu allo scroll.
 *
 * Osserva gli elementi `[data-md-reveal]` e li marca `data-md-revealed` quando
 * entrano nel viewport. Lo stato nascosto l'ha già attivato prima del paint lo
 * script inline di `snippets/md-head.liquid`: se lì il motion non è stato
 * acceso (reduced motion, niente IntersectionObserver, customizer) qui non c'è
 * nulla da fare e il contenuto è già visibile.
 */

/** Rete di sicurezza per ciò che è già a schermo. */
const SAFETY_MS = 1200;

function reveal() {
  const root = document.documentElement;
  if (root.dataset.mdMotion !== 'on') return;

  root.dataset.mdRevealReady = 'true';

  const targets = Array.from(document.querySelectorAll('[data-md-reveal]'));
  if (targets.length === 0) {
    delete root.dataset.mdMotion;
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.setAttribute('data-md-revealed', 'true');
        observer.unobserve(entry.target);
      }
    },
    // L'entrata parte quando la sezione è entrata per davvero, non appena sfiora il bordo.
    { rootMargin: '0px 0px -12% 0px' }
  );

  for (const el of targets) observer.observe(el);

  window.setTimeout(() => {
    for (const el of targets) {
      const box = el.getBoundingClientRect();
      if (box.top < window.innerHeight && box.bottom > 0) el.setAttribute('data-md-revealed', 'true');
    }
  }, SAFETY_MS);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', reveal, { once: true });
} else {
  reveal();
}
